"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aspect = void 0;
const metadata_1 = require("./metadata");
class Aspect extends metadata_1.Metadata {
    constructor($key, description, initializer) {
        super();
        this.apply({
            language: {
                default: {
                    name: $key,
                    description,
                    //          uid: count++
                },
            },
            protocol: {},
        }, initializer);
    }
}
exports.Aspect = Aspect;
//# sourceMappingURL=aspect.js.map